module.exports = __webpack_public_path__ + "static/media/Center_Of_The_Body.b8e6fdc3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/position_icons/Center_Of_The_Body.svg
// module id = 749
// module chunks = 0